export const UTF8_BOM = "\ufeff";
export const CSV_DELIMITER = ";";

const escapeCell = (value: unknown): string => {
  const cell = value === null || value === undefined ? "" : String(value);

  return `"${cell.replace(/"/g, '""')}"`;
};

export const buildCsvContent = (headers: string[], rows: unknown[][]): string =>
  UTF8_BOM + [headers, ...rows].map((row) => row.map(escapeCell).join(CSV_DELIMITER)).join("\r\n");

export const downloadCsvFile = (fileName: string, content: string) => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};